import { createContext, useContext } from 'react'

import moment, { Moment } from 'moment'

interface Props {
  date: Moment
}

const context = createContext<Props>({ date: moment() })

export const DateBookingProvider = context.Provider
export const useDateBookingContext = () => useContext(context)
